import { useState, useEffect } from 'react';

const useMedia = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);

    const listener = () => setMatches(mediaQuery.matches);

    mediaQuery.addListener(listener);

    return () => mediaQuery.removeListener(listener);
  }, []);

  return matches;
};
export default useMedia;

